export default __webpack_public_path__ + "static/media/loader.73edce97.svg";